import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { InputFecha } from "../../../../components/formComponents/InputFecha";
import { DataContext } from "../../../../contextData/contextData";
import ErrorInput from "../../../../components/ui/ErrorInput";
import { FIELD_LABEL_STYLE } from "../ModalEditarSolicitud";
import { getUno } from "../../../../api/apis";

const OPCIONES_CONTRATO = [
  { value: "01", label: "Cambiar estatus a indefinido" },
  { value: "02", label: "Extensión de plazo fijo" },
];

export const EditarCambioContrato = ({ formik, solicitud, onLoadingChange }) => {
  const { uno } = useContext(DataContext);
  const [datosMiddleware, setDatosMiddleware] = useState(null);

  useEffect(() => {
    const rut = solicitud?.persona?.identificacion;
    if (rut) {
      if (onLoadingChange) onLoadingChange(true);
      getUno("personasporjefe", { rut })
        .then((resp) => {
          if (resp?.data?.success && resp?.data?.data) {
            setDatosMiddleware(resp.data.data);
          }
        })
        .catch((err) => console.error("Error obteniendo datos del colaborador en MW:", err))
        .finally(() => {
          if (onLoadingChange) onLoadingChange(false);
        });
    }
  }, [solicitud?.persona?.identificacion]);

  // Obtener tipo y nro de tipo de contrato desde Middleware o fallbacks
  const reeoTipoContrato =
    datosMiddleware?.REEO_TIPO_CONTRATO ||
    uno?.["REEO_TIPO_CONTRATO"] ||
    solicitud?.persona?.tipo_contrato;

  const reeoNroTipoContrato =
    datosMiddleware?.REEO_NRO_TIPO_CONTRATO ||
    uno?.["REEO_NRO_TIPO_CONTRATO"];

  const getOpcionesContrato = () => {
    // Si en el Middleware REEO_NRO_TIPO_CONTRATO es "02", por ley debe pasar a indefinido
    if (String(reeoNroTipoContrato).trim() === "02") {
      return [{ value: "01", label: "Cambiar estatus a indefinido" }];
    }

    // Si tiene REEO_TIPO_CONTRATO: "02" y REEO_NRO_TIPO_CONTRATO: "01", tiene ambas opciones (indefinido o extensión plazo fijo)
    if (
      String(reeoTipoContrato).trim() === "02" &&
      String(reeoNroTipoContrato).trim() === "01"
    ) {
      return OPCIONES_CONTRATO;
    }

    // Fallback: Si la solicitud actual ya fue registrada como extensión de plazo fijo ("02" o 2)
    const tipoActualSolicitud = String(solicitud?.tipo_cambio_contrato || "").trim();
    if (["02", "2"].includes(tipoActualSolicitud)) {
      return OPCIONES_CONTRATO;
    }

    // Si el contrato ya es indefinido ("01"), solo opción indefinido
    if (String(reeoTipoContrato).trim() === "01") {
      return [{ value: "01", label: "Cambiar estatus a indefinido" }];
    }

    return OPCIONES_CONTRATO;
  };

  const opciones = getOpcionesContrato();
  const currentTipoCambio = String(formik.values.tipo_cambio_contrato || "").trim();

  useEffect(() => {
    if (!["02", "2"].includes(currentTipoCambio)) {
      if (formik.values.fecha_renovacion_contrato) {
        formik.setFieldValue("fecha_renovacion_contrato", "");
      }
    }
  }, [currentTipoCambio]);

  return (
    <>
      <div>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <label htmlFor="tipo_cambio_contrato" style={{ ...FIELD_LABEL_STYLE, marginBottom: 0 }}>
            NUEVO ESTATUS CONTRATO SOLICITADO <span className="text-danger">*</span>
          </label>
          {formik.errors.tipo_cambio_contrato && formik.touched.tipo_cambio_contrato && (
            <ErrorInput
              touched={formik.touched.tipo_cambio_contrato}
              error={formik.errors.tipo_cambio_contrato}
            />
          )}
        </div>
        <Select
          id="tipo_cambio_contrato"
          name="tipo_cambio_contrato"
          className="selectDos"
          classNamePrefix="limpiarSelect"
          options={opciones}
          value={opciones.find((opt) => String(opt.value) === currentTipoCambio) || null}
          onChange={(opt) => {
            formik.setFieldValue("tipo_cambio_contrato", opt ? opt.value : "");
          }}
          placeholder="---Seleccione---"
          isClearable={true}
          menuPlacement="auto"
          menuPosition="fixed"
          maxMenuHeight={220}
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
      </div>

      {["02", "2"].includes(currentTipoCambio) && (
        <InputFecha
          formik={formik}
          label="NUEVA FECHA EXTENSIÓN DE PLAZO FIJO *"
          labelStyle={FIELD_LABEL_STYLE}
          id="fecha_renovacion_contrato"
        />
      )}
    </>
  );
};

EditarCambioContrato.propTypes = {
  formik: PropTypes.object.isRequired,
  solicitud: PropTypes.object,
  onLoadingChange: PropTypes.func,
};
